import { types, API_URL } from './types';
import { axiosApi } from './index';

export const getSalesByProvider = (start = '', end = '') => {
  let url = `${API_URL}/api/v1/sales/by-provider?start=${start}&end=${end}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetSalesByProvider(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetSalesByProvider(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        if (error.response) {
          const status = error.response.status;
          if (status === 401) {
            outputData['message'] = 'No tienes permisos para acceder a ventas.';
          } else if (status === 403) {
            outputData['message'] = 'Acceso denegado';
          } else {
            outputData['message'] =
              error.response.data?.message || 'Error al cargar ventas por proveedor';
          }
        } else {
          outputData['message'] = 'Error de conexión con el servidor';
        }
        dispatch(setGetSalesByProvider(outputData));
      });
  };
};

export const setGetSalesByProvider = (data) => ({
  type: types.smGetSalesByProvider,
  payload: data,
});

export const getSalesBySeller = (start = '', end = '') => {
  let url = `${API_URL}/api/v1/sales/by-seller?start=${start}&end=${end}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .get(url)
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setGetSalesBySeller(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setGetSalesBySeller(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        if (error.response) {
          const status = error.response.status;
          if (status === 401) {
            outputData['message'] = 'No tienes permisos para acceder a ventas.';
          } else if (status === 403) {
            outputData['message'] = 'Acceso denegado';
          } else {
            outputData['message'] =
              error.response.data?.message || 'Error al cargar ventas por vendedor';
          }
        } else {
          outputData['message'] = 'Error de conexión con el servidor';
        }
        dispatch(setGetSalesBySeller(outputData));
      });
  };
};

export const setGetSalesBySeller = (data) => ({
  type: types.smGetSalesBySeller,
  payload: data,
});
